import React, { useState } from 'react'
import styles from './CreateClientManagerModal.module.css'
import { Formik, FormikValues } from 'formik'
import { useDispatch } from 'react-redux'
import { createClient } from '../../redux/actions/clientsAction'
import CustomInput from '../UI/CustomInput/CustomInput'
import CustomButton from '../UI/CustomButton/CustomButton'
import { createManager } from '../../redux/actions/clientManagersAction'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import close from '../../assets/icons/close.svg'
interface CreateClientManagerModalProps {
  isOpen: boolean
  onClose: () => void
  clientId: number
}

const CreateClientManagerModal: React.FC<CreateClientManagerModalProps> = ({
  isOpen,
  onClose,
  clientId,
}) => {
  if (!isOpen) return null

  const { isLoading, error, token } = useAppSelector((state) => state.auth)
  const { currentManager, managers } = useAppSelector((state) => state.managers)
  const [submittedValues, setSubmittedValues] = useState<any>(null)
  const dispatch = useAppDispatch()

  const handleSubmitHandler = async (values: FormikValues) => {
    setSubmittedValues({ ...values })
    const submitData = {
      fullName: values?.fullName,
      email: values?.email,
      phone: values?.phone,
      position: 'Менеджер',
      clientId: clientId,
    }

    dispatch(
      createManager({
        data: submitData,
        token,
      }),
    )
  }

  return (
    <div className={styles.registrationModalOverlay}>
      <div className={styles.registrationModal}>
        <div className={styles.titleBlock}>
          <h1 className={styles.title}>Создание менеджера</h1>
          <img onClick={onClose} className={styles.close} src={close} alt='close' />
        </div>
        <div className={styles.inputsContainer}>
          <Formik
            initialValues={
              submittedValues || {
                fullName: '',
                phone: '',
                email: '',
                clientId: '',
                position: 'Менеджер',
              }
            }
            validateOnBlur
            onSubmit={(values) => handleSubmitHandler(values)}
          >
            {(props) => {
              const { values, isValid, handleChange, handleBlur, handleSubmit } = props

              return (
                <>
                  <div className={styles.formContainer}>
                    <div className={styles.inputGroup}>
                      <div className={styles.inputContainer}>
                        <h4 className={styles.subtitle}>ФИО</h4>
                        <CustomInput
                          type='text'
                          placeholder='ФИО'
                          name='fullName'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.fullName}
                        />
                      </div>
                      <div className={styles.inputContainer}>
                        <h4 className={styles.subtitle}>Номер телефона</h4>
                        <CustomInput
                          type='text'
                          placeholder='Номер телефона'
                          name='phone'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.phone}
                        />
                      </div>
                      <div className={styles.inputContainer}>
                        <h4 className={styles.subtitle}>Электронная почта/Логин</h4>
                        <CustomInput
                          type='text'
                          placeholder='Электронная почта'
                          name='email'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values?.email?.trim()}
                        />
                      </div>
                    </div>
                  </div>
                  <div className={styles.footerContainer}>
                    <CustomButton
                      title='Создать'
                      disabled={!isValid}
                      onClick={() => handleSubmit()}
                      type='submit'
                      className={''}
                    />
                  </div>
                </>
              )
            }}
          </Formik>
        </div>
      </div>
    </div>
  )
}

export default CreateClientManagerModal
